import { Briefcase, FileText, MousePointerClick, RefreshCw, Smartphone, Code2, ArrowUpRight } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Stagger, StaggerItem } from "./Reveal";
import { useSectionNav } from "@/lib/scroll";

const services = [
  { id: "business", icon: Briefcase, title: "Business Websites", text: "Professional websites for small businesses and companies." },
  { id: "quotes", icon: FileText, title: "Quote Request Websites", text: "Websites built to turn visitors into enquiries, with simple quote request forms that land straight in your inbox." },
  { id: "landing", icon: MousePointerClick, title: "Landing Pages", text: "High-converting landing pages for advertising campaigns, products and services." },
  { id: "redesign", icon: RefreshCw, title: "Website Redesigns", text: "Modernise an outdated website with a cleaner, faster and more professional design." },
  { id: "responsive", icon: Smartphone, title: "Mobile Responsive Design", text: "Websites that look excellent across phones, tablets and desktops." },
  { id: "custom", icon: Code2, title: "Custom Website Development", text: "Custom functionality built around the customer's requirements." },
];

export const Services = () => {
  const goTo = useSectionNav();
  return (
    <section id="services" className="section" aria-labelledby="services-title">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <SectionHeading id="services-title" eyebrow="Services" title="Everything your business needs online." subtitle="From a first website to a full redesign, each project is designed and built around what your business actually needs — then we launch your new website and take care of it as well." />
          <button onClick={() => goTo("quote")} className="btn-secondary self-start lg:self-auto" data-testid="services-quote-btn">
            Get a Free Quote <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </button>
        </div>

        <Stagger className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {services.map(({ id, icon: Icon, title, text }, i) => (
            <StaggerItem key={id}>
              <article className="card-dark card-hover group h-full p-7 sm:p-8 overflow-hidden" data-testid={`service-card-${id}`}>
                <div className="absolute -right-10 -top-10 h-32 w-32 rounded-full bg-indigo-500/10 blur-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-700" aria-hidden="true" />
                <div className="flex items-start justify-between">
                  <span className="grid h-12 w-12 place-items-center rounded-2xl border border-white/10 bg-gradient-to-br from-indigo-500/20 to-violet-500/10 text-indigo-200">
                    <Icon className="h-5 w-5" aria-hidden="true" />
                  </span>
                  <span className="font-mono text-xs text-slate-600">0{i + 1}</span>
                </div>
                <h3 className="mt-7 text-xl font-semibold text-white">{title}</h3>
                <p className="mt-3 text-sm sm:text-base text-slate-400 leading-relaxed">{text}</p>
              </article>
            </StaggerItem>
          ))}
        </Stagger>
      </div>
    </section>
  );
};
